/**
 * DocumentsShell — domain frame for Documents & Disclosures config.
 *
 * The disclosure-engine config behind every account-open packet: which
 * disclosure bodies render (verbatim text), the per-template-type authoring
 * lifecycle (draft → review → approval → publish), and the document-
 * requirement matrix. All of it drives what the customer signs.
 *
 * New module landed 2026-06-16 (BACKLOG-0579/0100) as the migrate target for
 * the ROP-teams Admin disclosure editors. Mirrors ComplianceShell /
 * ReferenceShell — a DomainShell with a role-gated sub-nav.
 */

import { useAuth } from '@/contexts/AuthContext';
import { DomainShell } from '@/components/DomainShell';

const REQ = ['SuperAdmin', 'Admin', 'DisclosureManager', 'RiskManager'] as const;

const SUBNAV = [
  { slug: 'document-requirements', label: 'Document Requirements', requiredRoles: REQ },
  { slug: 'disclosure-bodies', label: 'Disclosure Bodies', requiredRoles: REQ },
  { slug: 'template-lifecycle', label: 'Template Lifecycle', requiredRoles: REQ },
];

export function DocumentsShell(): JSX.Element {
  const { user } = useAuth();
  return (
    <DomainShell
      title="Documents & Disclosures"
      description="The disclosure-engine config behind every account-open packet. Disclosure Bodies hold the verbatim text the engine renders; Template Lifecycle defines the per-template-type authoring stages (draft → review → approval → publish) and peer-review requirement. Document Requirements (the Disclosure-Engine matrix) slots in as a sibling. Changes here ripple into every disclosure a customer signs — edit deliberately."
      basePath="/retail/documents"
      items={SUBNAV.map((s) => ({
        slug: s.slug,
        label: s.label,
        requiredRoles: s.requiredRoles,
      }))}
      userRoles={user?.roles ?? []}
    />
  );
}
